import { Grid } from "@mui/material";
import FormCard from "./FormCard";

export default function FormTypes({ account, setFormType }) {
  return (
    <>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <FormCard
            title="Zgłoszenie przez konto ZHP"
            subtitle="Jeżeli należysz do ZHP i chcesz dodać zgłoszenie nieanonimowe, to skorzystaj z tej opcji. Wypełnimy formularz Twoimi danymi kontaktowymi na podstawie konta ZHP. Jeżeli będziemy mieli dodatkowe pytania lub potrzebowali szczegółów, to skontaktujemy się z Tobą."
            onClick={() => setFormType(2)}
            disabledNote="Aby skorzystać z tej opcji zaloguj się kontem ZHP, korzystając z przycisku w prawym górnym rogu."
            disabled={!account}
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <FormCard
            title="Zgłoszenie nieanonimowe"
            subtitle="Poprosimy Cię o podanie danych kontaktowych. Po przesłaniu formularza otrzymasz potwierdzenie mailowe o przyjeciu zgłoszenia i wygenerowany numer. Jeżeli będziemy mieli dodatkowe pytania lub potrzebowali szczegółów, to skontaktujemy się z Tobą."
            onClick={() => setFormType(1)}
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <FormCard
            title="Zgłoszenie anonimowe"
            subtitle="Nie będziemy Cię prosić o podanie danych kontaktowych. Po przesłaniu formularza zobaczysz infromację potwierdzającą przyjęcie zgłoszenia i wygenerowany numer. Nie będziemy się w stanie z Tobą skontaktować, aby dzięki informacjom od Ciebie mieć szansę skuteczniej zaplanować działania interwencyjne w tej sprawie. Interwencja może być mniej skuteczna. Nie dowiesz się, czy sprawa została przyjęta do realizacji czy odrzucona."
            onClick={() => setFormType(0)}
          />
        </Grid>
      </Grid>
    </>
  );
}
